module.exports = __webpack_public_path__ + "img/icon-avatar-shadow.15aa91f3.png";